import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

interface PortalRendererProps {
	containerId: string;
	component: React.FunctionComponent<any>;
	componentProps: object;
}

const PortalRenderer = ({ containerId, component: Component, componentProps, }: PortalRendererProps) => {
	const [ container, setContainer, ] = useState<HTMLElement | null>(null);

	useEffect(() => {
		const containerElement = document.getElementById(containerId);
		if (containerElement) {
			setContainer(containerElement);
		} else {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					if (mutation.addedNodes.length) {
						const containerElement = document.getElementById(containerId);
						if (containerElement) {
							setContainer(containerElement);
							observer.disconnect();
						}
					}
				});
			});

			observer.observe(document.body, { childList: true, subtree: true, });

			return () => observer.disconnect();
		}
	}, [ containerId, ]);

	if (!container) {
		return null; 
	}

	return createPortal(<Component {...componentProps} />, container);
};

export default PortalRenderer;
